/**
 * @file   src\Pages\TrackOrder.tsx
 * @brief  Track Order page.
 * @date   JUL, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { Container, Breadcrumb, Button, useOutletContext, useNavigate, useEffect, useState, useLocation, Badge } from '../utils/thirdpartyComponents';
import CWSearchinput from '../components/CWSearchinput';
import { Stepper, Step } from 'react-form-stepper';
import { AppContextType, ICarwashOwnerProp } from '../interfaces/generalInterface';
import Deviceicon from '../assets/images/computer-chip.svg';
import CWSelect from '../components/CWSelect';
import Addresspinicon from '../assets/images/address-pin-icon.svg';
import { pageURLs } from '../utils/pageUrls';
import { userType } from '../utils/enums';

const TrackOrder = (props: any) => {
    const carwash_owner = (props.userType === userType['CARWASH-OWNER']) ? true : false;
    const search = props.search ;
    const [shiplist, setshiplist] = useState([
        { label: 'Ordered', value: '1' , className:'myclass' },
        { label: 'Order Processing', value: '2' },
        { label: 'Shipped', value: '3' }, 
        { label: 'Delivered', value: '4' }
    ]);
    const [showDetails,setShowDetails] = useState(false)
    const [trackId,setTrackId] = useState('')

    // Access the context
    const { data, updateData } = useOutletContext<AppContextType>();

    // To get path from which redirection was done
    const location = useLocation();
    const origin = location.state?.origin || 'Unknown';

    const companyDetailsArray = [
        {
            "Car Wash Name": "Lara Car Wash",
            "Owner Name": "Lara Stephen",
            "Address": "285 Amherst St, Anytown, CA 12345",
            "Phone Number": "+1-555-082-9164",
            "Email Address": "sample1@mail.com",
            "No. of Car Wash Locations": 2,
            "Subscription Payment Date": "06/13/2024",
            "Subscription Status": "Active"
        },
        {
            "Car Wash Name": "Camps Car Wash",
            "Owner Name": "John Morrow",
            "Address": "789 Levert St, West Fort Lauderdale, CA 38955",
            "Phone Number": "+1-233-232-8989",
            "Email Address": "sample1@mail.com",
            "No. of Car Wash Locations": 1,
            "Subscription Payment Date": 'NA',
            "Subscription Status": "Inactive"
        },
        {
            "Car Wash Name": "Golden Car Wash",
            "Owner Name": "George Doe",
            "Address": "900 Houston St, Warminster, CA 321671",
            "Phone Number": "+1-124-353-7675",
            "Email Address": "sample1@mail.com",
            "No. of Car Wash Locations": 1,
            "Subscription Payment Date": "05/15/2024",
            "Subscription Status": "Active"
        },

    ]


    // State to display company details
    const [companyDetails, setCompanyDetails] = useState(companyDetailsArray)

    // State to handle search
    const [searchValue, setSearchValue] = useState<string>('')

    // To display heading
    useEffect(() => {
        if(search==false)
            setShowDetails(true)
        handleUpdate()
    }, [])

    // Update the data
    const handleUpdate = () => {
        updateData({ heading: "Track Order", url: carwash_owner==true ? `/${pageURLs.order_details}`:`/superadmin/${pageURLs.manage_hardware}` , showBackButton: origin === "MainMenu" ? false : true, showMainMenu: true, activeLink: "hardware" });
    };

    // Triggers when input is entered in search
    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setSearchValue(value);
        if(value.length >6)
        {
            setTrackId(value)
            performSearch(value);

        }
        //Search Functionality
       
    }

    // Filter data based on the search value
    const performSearch = (query: string) => {
        if (query.trim() === '') {
            setCompanyDetails(companyDetailsArray);
        } else {
            setShowDetails(true)
            const results = companyDetailsArray.filter(item =>
                item["Car Wash Name"].toLowerCase().includes(query.toLowerCase()) ||
                item["Owner Name"].toLowerCase().includes(query.toLowerCase())
            );
            setCompanyDetails(results);
        }
    };

    const handleClearSearch = () => {
        setSearchValue('');
        setCompanyDetails(companyDetailsArray);
    };

    return (

        <div className='manage-carwash-container order-list-container'>
            <Container>
                {/* <Breadcrumb>
                    <Breadcrumb.Item href="#">Hardware Listing</Breadcrumb.Item>
                    <Breadcrumb.Item href="#"> Manage Hardware</Breadcrumb.Item>
                    <Breadcrumb.Item href="#">Order List</Breadcrumb.Item>
                    <Breadcrumb.Item active>Track Order</Breadcrumb.Item>
                </Breadcrumb> */}
                <div className="manage-header-block d-flex justify-content-between align-items-center">
                <div className="search-wrap order-search w-100 d-flex align-items-center">
                {(search == true) &&  <CWSearchinput
                            id="search"
                            name="search"
                            type="text"
                            placeholder=" Search..."
                            value={searchValue}
                            onChange={handleSearch}
                            onClose={handleClearSearch}
                            maxLength={8}

                        />}
                     {(showDetails == true) &&    <h6><span className='f-semi'>Tracking ID:</span>{(showDetails == true && trackId )? trackId : "CW46786"}</h6>}
                    </div>
                </div>
                
                {(showDetails == true) && <div className="order-content-wrap d-flex flex-column">
                    <div className="order-detail-sec d-flex">
                        <div className="device-frame d-flex"><img src={Deviceicon} alt="Car Wash App" /></div>
                        <div className="content-sec">
                            <div className="order-info d-flex">
                                <div className="list-item">
                                    <p>Order Number</p>
                                    <h2 className='f-semi'>7995352</h2>
                                </div>
                                {carwash_owner != true && <><div className="list-item">
                                    <p className='name'>Company Name</p>
                                    <h6 className='f-semi'>Car Wash Station Name</h6>
                                </div>
                                <div className="list-item">
                                    <p className='name'>Owner Name</p>
                                    <h6 className='f-semi'>John Doe</h6>
                                </div> </>}
                            </div>
                            <div className="ship-info d-flex align-items-center">
                               {carwash_owner != true ? <CWSelect
                                    id="shipinfo"
                                    name="shipinfo"
                                    options={shiplist}
                                    dropdownGap={0}
                                    dropdownPosition="auto"
                                    placeholder="Select"
                                    multi={false}
                                /> : <Badge className="alert m-0">Shipped</Badge>} 
                                <p>On <span className='f-semi'>06/06/2024</span></p>
                            </div>
                            <div className="info-pills d-flex">
                                <div className="pill-item"><span className="f-semi">Quantity:</span> 1</div>
                                <div className="pill-item"><span className="f-semi">Amount:</span> $452</div>
                                <div className="pill-item"><span className="f-semi">Device ID:</span> XYWZ78901</div>
                                <div className="pill-item"><span className="f-semi">Ordered Date:</span> 06/05/2024</div>
                            </div>
                        </div>
                    </div>
                    <div className="address-sec d-flex align-items-center justify-content-between">
                        <div className="address-block d-flex align-items-start">
                            <img src={Addresspinicon} alt="Car Wash App" />
                            <div className="address-info">
                                <h6 className='f-bold'>Shipping Address</h6>
                                <p>1974 Terra Cotta Street <br />
                                Minneapolis, MN 55402</p>
                            </div>
                        </div>
                        <div className="track-sec position-relative">
                            <Stepper activeStep={1} className='stepper-main' stepClassName='single-step'>
                                <Step completed label="Item Dispatched" />
                                <Step active label="Item In Transit" />
                                <Step label="Item Delivered" />
                            </Stepper>
                            <div className="delivery-time">Expected Delivery Date <br />
                            <span className='f-semi'>06-08-2024</span></div>
                        </div>
                    </div>
                </div>}
            </Container >
        </div >
    )
}

export default TrackOrder;
